import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { SharedServiceService } from '../../../shared-service.service';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-modal-rename',
  templateUrl: './modal-rename.component.html',
  styleUrls: ['./modal-rename.component.scss']
})
export class ModalRenameComponent implements OnInit {

  projectCurrentName = '';

  constructor(
    public dialogRef: MatDialogRef<ModalRenameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public newProject: ProjectManagerService,
    public sharedService: SharedServiceService,
    public auth: AuthService
  ) { }

  closeDialog() {
    this.dialogRef.close();
  }

  rename() {
    if (this.auth.getRole() == "admin") {
      this.newProject.updateTemplateItem(this.data.project.id, "projectName", this.projectCurrentName).subscribe(res => console.log(res));
      this.sharedService.broadcast('renameTemplate', 'some message');
    }
    else {
      this.newProject.updateProjectItem(this.data.project.id, "projectName", this.projectCurrentName).subscribe(res => console.log(res));
      this.sharedService.broadcast('renameProject', 'some message');
    }

  }

  ngOnInit() {
    this.projectCurrentName = this.data.project.projectName;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-rename/modal-rename.component.ts